import {
  Box,
  Expand,
  FileUser,
  FlaskConical,
  Headset,
  Image,
  Languages,
  ListChecks,
  LoaderPinwheel,
  Mail,
  Siren,
  Lightbulb,
  Type,
  Users,
  Video,
  Waypoints,
  Workflow,
  Wrench,
  ChartColumnIncreasing,
  ClapperboardIcon,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { CATEGORY_COLORS, type CategoryId } from '@/shared/constants/category-colors';

const LUCIDE_ICONS: Record<string, LucideIcon> = {
  'audience-flow-agent': Users,
  'strategy-agent': Waypoints,
  'strategy-agent-v2': Waypoints,
  'strategy-agent-v3': Waypoints,
  'flow-digest-agent': Workflow,
  'opportunities-room': Siren,
  'external-tools-agent': Wrench,
  'content-test-agent': FlaskConical,
  'content-test': FlaskConical,
  'focus-group-agent': FileUser,
  'copy-generation': Type,
  'email-flow-agent': Mail,
  templates: Mail,
  ideation: Lightbulb,
  'image-generation': Image,
  'video-generation': Video,
  'content-studio': LoaderPinwheel,
  'creative-flows': Workflow,
  'reels-creator': ClapperboardIcon,
  'reels-creator-hosted': ClapperboardIcon,
  'translation-agent': Languages,
  Adaptation: Expand,
  'quality-assurance': ListChecks,
  'monksflow-sales-support': Headset,
  'briefing-agent': FileUser,
  'social-media-brief': FileUser,
  'general-support': Headset,
  'training-videos': Video,
  iq: ChartColumnIncreasing,
};

export const ToolIconsV4 = (
  agentId: string,
  tag: string,
  size: number,
  className?: string,
  colorOverride?: string,
): React.ReactElement => {
  const normalizedTag = tag.toLowerCase() || '';
  const isValidTag = (key: string): key is CategoryId => key in CATEGORY_COLORS;

  const categoryColors = isValidTag(normalizedTag)
    ? CATEGORY_COLORS[normalizedTag]
    : CATEGORY_COLORS.deliver;
  const color =
    colorOverride ??
    ('icon' in categoryColors ? (categoryColors as { icon: string }).icon : categoryColors.text);

  // First, try exact match
  let LucideIcon = LUCIDE_ICONS[agentId] as LucideIcon | undefined;

  // If no exact match, check for prefix matches (e.g., audience-flow-persona-1, audience-flow-persona-2)
  if (!LucideIcon) {
    if (agentId && agentId.startsWith('audience-flow')) {
      LucideIcon = LUCIDE_ICONS['audience-flow-agent'];
    }
  }

  const Icon = LucideIcon ?? Box;
  return <Icon size={size} color={color} className={className} />;
};
